export const ConceptualLabelDiscoveryTypes = {
    CONCEPTUAL_LABEL: 1,
    SEMANTIC: 2,
}


